"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GET_VIDEO_CARD_QUERY = void 0;
const helpers_1 = require("../../client/helpers");
const fragments_1 = require("./fragments");
exports.GET_VIDEO_CARD_QUERY = `
  query GetVideoCards($videoId: ID!) {
    video(filter: { id: $videoId }) {
      cards(limit: 100) {
        entities {
          ...VideoCardFragment
        }
      }
    }
  }
  ${fragments_1.VIDEO_CARD_FRAGMENT}
`;
//# sourceMappingURL=queries.js.map